<template>
  <v-container>
    <v-card class="mx-auto" max-width="1400">
      <title-bar></title-bar>
      <v-img
        class="white--text align-end"
        height="400px"
        src="https://dutchbros.com/public/images/franchise/bg.jpg"
      >
      </v-img>

      <v-card-text class="text--primary text-center">
        <div>
          <p class="primary--text text-h5 font-weight-medium mt-7">
            Thanks {{ firstName }}! We're stoked to meet you!
          </p>
        </div>

        <div>
          <p
            class="primary--text text-subtitle-1"
            style="margin-bottom: 0 !important"
          >
            Dutch Bros has received your contact information and we'll be
            sending hiring updates soon!
          </p>
          <p class="primary--text text-subtitle-1 mb-5">
            Until then, please finish your application here:
          </p>
          <application-link></application-link>
        </div>
      </v-card-text>
      <footer-bar></footer-bar>
    </v-card>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar.vue";
import FooterBar from "../components/Footer";
import ApplicationLink from "../components/ApplicationLink.vue";

export default {
  components: { ApplicationLink, FooterBar, TitleBar },

  computed: {
    firstName: {
      get() {
        return this.$store.state.firstName;
      },
      set(value) {
        this.$store.commit("setFirstName", { firstName: value });
      },
    },
  },

  data: () => ({
    valid: false,
    loading: true,
    first_temp: "",
    resumeFile: {},
    fileTemp: false,
  }),
  props: {
    source: String,
  },

  methods: {
    reset() {
      let firstName = this.firstName;
      console.log("Thanks for visiting... ");
      window.localStorage.clear();
      this.$store.dispatch('resetState');
      this.first_temp = firstName;
    },
    getUploadedFile() {
      this.resumeFile = event.target.files[0];
      this.fileTemp = true;
    },
    uploadFile() {
      // send resumeFile
      console.log(this.resumeFile);
    },
  },
  mounted() {
    this.reset();
  },
};
</script>
